// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const commonErrorApiCodeReasonAuthShared = {
  activityMemberInactive: "The {resource} activity member is inactive",
  activityRoleRequired: "Your account does not have the required {resource} activity role",
  adminAccessRequired: "Your account does not have {resource} administrator access",
  appSessionRequired: "The current request is missing a {resource} app session",
  applicationAccessDenied: "Your account cannot access the {resource} application",
  applicationContextInvalid: "The {resource} application context is invalid",
  authorizationPromptInvalid: "The {resource} authorization prompt is not allowed",
  avatarMustBeImage: "The {resource} avatar must be an image",
  candidateAccountExpired: "The {resource} candidate account has expired",
  invalidAuthMode: "The {resource} authentication mode is invalid",
  invalidReturnPath: "The {resource} return path must be a valid in-app relative path",
  invalidSsoBffResponse: "The {resource} SSO BFF response does not match the contract",
  memberAccessRequired: "Your account does not have {resource} member access",
  memberInactive: "The {resource} member is inactive",
  missingRefreshToken: "The {resource} refresh token is missing",
  oidcRequestFailed: "The {resource} OIDC/BFF request failed",
  oidcTransactionMissing: "The {resource} OIDC callback is missing the authorization transaction",
  redirectUriNotConfigured: "The {resource} OIDC callback redirect URI is not configured",
  sessionInvalidated: "The {resource} session has been invalidated. Sign in again",
  siteMaintenance: "The {resource} site is under maintenance",
  ssoBffNotConfigured: "The {resource} SSO BFF client is not fully configured",
  ssoBootstrapFailed: "The {resource} SSO bootstrap failed",
  teacherAccessRequired: "Your account does not have {resource} teacher access",
  userInactiveOrNotFound: "The {resource} user is inactive or was not found",
} as const;
